import _ from 'lodash';
import { createSelector } from 'reselect';

const organizationSelector = state => state.organization;

const integrationSelector = (organization) => {

  const organizationData = organization.data || {};

  if(organizationData.integrations && organizationData.integrations.salesforce && organizationData.integrations.salesforce.status === 'live'){
    return 'salesforce';
  }
  else{
    return false;
  }
}

export default createSelector(
  organizationSelector,
  integrationSelector
)



// WEBPACK FOOTER //
// ./src/selectors/integrationSelector.js